import React from 'react'
import { ContentType } from '../../../server/models/GenericContentFields'

const contentTypeOptions = [
  { value: 'summary', label: 'Three Sentence Summaries' },
  { value: 'blog', label: 'Blog Outlines' },
  { value: 'carousel', label: 'Carousel Slides' },
  { value: 'shortVideo', label: 'Short Video Scripts' },
] as { value: ContentType, label: string }[]

type Props = {
  selectedContentTypes: ContentType[]
  onSelectedContentTypes: (selectedContentTypes: ContentType[]) => void
}
export const SelectContentTypes: React.FC<Props> = ({
  selectedContentTypes,
  onSelectedContentTypes
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>, option: { value: string, label: string }) => {
    if (e.target.checked) {
      onSelectedContentTypes([...selectedContentTypes, option.value as ContentType])
    } else {
      onSelectedContentTypes(selectedContentTypes.filter(type => type !== option.value))
    }
  }

  return (
    <label htmlFor="contentTypes">
      Filter by Content Type
      <div className="filter-box">
        {
          contentTypeOptions.map(option => (
            <label htmlFor={option.value} key={option.value}>
              <input
                key={option.value}
                type="checkbox"
                name={option.value}
                id={option.value}
                checked={selectedContentTypes.includes(option.value)}
                onChange={(e) => handleChange(e, option)}
              />
              <span className={`content-badge ${option.value}`}>{option.label}</span>
            </label>
          ))
        }
      </div>
    </label>
  )
}
